import { useEffect, useRef } from 'react'
import { setToken } from '../auth'

// Minimal typings for the GSI global
declare global {
  interface Window {
    google?: {
      accounts: {
        id: {
          initialize: (config: object) => void
          prompt: () => void
          renderButton: (element: HTMLElement, config: object) => void
        }
      }
    }
  }
}

interface Props {
  onLogin: (token: string) => void
}

export default function LoginPage({ onLogin }: Props) {
  const buttonRef = useRef<HTMLDivElement>(null)
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string

  useEffect(() => {
    function initGsi() {
      if (!window.google) return

      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: (response: { credential: string }) => {
          setToken(response.credential)
          onLogin(response.credential)
        },
        auto_select: true,
      })

      // Render the explicit sign-in button
      if (buttonRef.current) {
        window.google.accounts.id.renderButton(buttonRef.current, {
          theme: 'filled_black',
          size: 'large',
          shape: 'pill',
          text: 'signin_with',
        })
      }

      // Attempt silent sign-in (One Tap / auto_select)
      window.google.accounts.id.prompt()
    }

    // GSI script may already be loaded or still loading
    if (window.google) {
      initGsi()
    } else {
      const script = document.querySelector('script[src*="accounts.google.com/gsi/client"]')
      script?.addEventListener('load', initGsi)
      return () => script?.removeEventListener('load', initGsi)
    }
  }, [clientId, onLogin])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100dvh',
      background: 'var(--bg)',
      gap: '2rem',
      fontFamily: 'var(--font)',
    }}>
      <div style={{ textAlign: 'center', color: 'var(--text)' }}>
        <div style={{ fontSize: '1.25rem', fontWeight: 600, letterSpacing: '0.01em' }}>Jontha assistant</div>
      </div>
      <div ref={buttonRef} />
    </div>
  )
}
